<template>
    <div id="account-list" class="wrapper">
        <div class="row justify-content-end header">
            <div class="search-bar">
                <div class="search-bar-right">
                    <!--<input type="text" v-model="searchTerm" autocomplete="off" name="search-account" id="search-account">-->
                    <custom-input type="text" v-model="searchTerm" name="search-account" class="search-account" />
                    <input type="submit" value="">
                </div>
            </div>
            <button class="primary" v-if="userIsSuperUser" v-on:click="openCreateAccountModal">Add account</button>
        </div>

        <div class="accounts-list row justify-content-start flex-wrap">
            <!-- TODO refactor -->
            <div class="row">
                <div v-if="accounts.length === 0" class="not-found">
                    <i class="material-icons">find_in_page</i>
                    <span>No accounts found...</span>
                </div>
                <div class="row accountListItem" v-else v-for="(account, key) in accounts" v-bind:key="key">
                    <section class="clickable" v-on:click="logIntoAccount(account)">
                        <h3>
                            <span v-if="account.id">{{account.id}}:</span>
                            {{account.name}}
                        </h3>
                        <section>
                            <p class="sub-text">{{account.type === 1 ? 'Production Account' : 'Test Account'}}</p>
                        </section>
                    </section>
                    <i class="material-icons edit" v-if="userIsSuperUser" v-on:click="openEditModal(account)">edit</i>
                </div>
            </div>
        </div>

        <section id="createAccountModal">
            <modal ref="createAccountModal">
                <div slot="modal-header">
                    Add new account
                </div>

                <div slot="modal-content" class="content">
                    <div class="row">
                        <!-- TODO: Disabled for now -->
                        <!--<div class="col-3 accountImgRow">-->
                            <!--<div class="accountImg">-->
                                <!--<img src="/" alt="">&lt;!&ndash; TODO: add custom account Image &ndash;&gt;-->
                            <!--</div>-->
                        <!--</div>-->
                        <div class="col">
                            <custom-input type="text" label="Account Name" ref="createAccountName" :validationRules="{ required: true }" maxlength="50" v-model="createAccountName" name="Account Name" />
                            <custom-input type="dropdown" label="Service" v-model="createAccountService" :items="servicesForCustomInput" />
                            <custom-input type="toggle" label="Test Account" v-model="createAccountType"/>
                        </div>
                    </div>
                </div>

                <div slot="modal-footer" class="footer">
                    <button class="secondary" v-on:click="closeModal('createAccountModal')">Close</button>
                    <button class="primary" v-on:click="createAccountValidation()">Create</button>
                </div>
            </modal>
        </section>

        <section id="editAccountModal">
            <modal ref="editAccountModal">
                <div slot="modal-header">
                    Edit this account
                </div>

                <div slot="modal-content" class="content">
                    <div class="row">
                        <div class="col">
                            <custom-input type="text" label="Account Name" ref="editAccountName" :validationRules="{ required: true }" maxlength="50" v-model="editAccountName" name="Account Name" />
                            <custom-input type="dropdown" label="Service" v-model="editAccountService" :items="servicesForCustomInput" />
                            <custom-input type="toggle" label="Test Account" v-model="editAccountType"/>
                        </div>
                    </div>
                </div>

                <div slot="modal-footer" class="footer">
                    <button class="secondary" v-on:click="closeModal('editAccountModal')">Close</button>
                    <button class="primary" v-on:click="editAccountValidation()">Save</button>
                </div>
            </modal>
        </section>

        <modal ref="deleteModal">
            <div slot="modal-header">
                Delete account
                <p style="color: red;">DELETE IS NO API CALL FOR YEY</p>
            </div>
            <div slot="modal-content">
                <p v-if="account">Are you sure you want to delete: {{account.name}}</p>
            </div>
            <div slot="modal-footer">
                <div class="row">
                    <div class="pro_frm user_details">
                        <input v-on:click="closeModal('deleteModal')" type="submit" name="" value="Cancel" class="btn_cancel col">
                        <input type="submit" name="" value="Delete" class="col">
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';
import modal from '@/components/additional/modal.vue';
import customInput from '@/components/additional/customInput.vue';
// Debounce: Very simple method to execute a function after a given time.
// If the function is called again within the given time, than the call before wont execute.
// If the function is not called again withing the given time again, then it will execute. etc
import debounce from 'lodash.debounce';
import { eventBus } from '../main';

export default {
    name: 'accountsList',
    mixins: [
        Default
    ],
    props: [],
    components: {
        modal,
        customInput
    },
    inject: {
        $validator: '$validator' // Get the parent $validator instance
    },
    data() {
        return {
            accounts: [],
            isActive: true,
            // Search properties
            searchTerm: '',
            previousSearchTerm: '',
            lastSearchTyped: 0,
            searchExecuted: false,
            // Create account properties
            createAccountName: '',
            createAccountService: '',
            createAccountType: false,
            // Edit account properties
            editAccountName: '',
            editAccountService: '',
            editAccountType: false,
            editAccountId: null,
            // Services
            services: null,
            servicesForCustomInput: null,
            // Delete account properties
            account: null,
            // Add users properties (searching in users per account)
            userSearchTerm: null,
            users: null,
            usersSearch: null,
            selectedAccount: {
                identification: '',
                name: ''
            }
        };
    },
    created: function() {
        // Log user out from account. So some menu items for account specific will not be shown.
        if (this.$store.getters[this.$store.types.loggedinAccount.getters.get].identification)
            this.$parleyAdmin.auth.logoutAccount();
            // Get all accounts
        this.searchAccounts(true);

        // When logging in using the sessionExpiredModal, refresh accounts list
        eventBus.$on('2faComplete', () => {
            this.searchAccounts(true);
        });
    },
    watch: {
        // When ever searchTerm changes
        searchTerm: function() {
            this.searchAccounts();
        },
        services: function(newVal, oldVal) {
            let newServices = [];
            newVal.forEach((service, index) => {
                newServices[index] = {value: service.id, label: service.name};
            });

            this.servicesForCustomInput = newServices;
        }
    },
    methods: {
        openCreateAccountModal: function() {
            this.$refs['createAccountName'].$validator.errors.clear();
            const modelName = 'createAccountModal';

            if (this.services === null) // Get the services and open the modal
                this.$http.get('v1.1/services/all').then(response => {
                    // Success callback
                    this.services = response.data.data.services;
                    this.createAccountService = this.services[0].id;

                    this.$refs[modelName].openModal();
                }, response => {
                    // Error callback
                    this.$parleyAdmin.queryErrors.addError('Something went wrong while retrieving the services list, please try again later.');
                });
            else // We already have services, so just open the modal
                this.$refs[modelName].openModal();
        },
        openEditAccountModal: function(account) {
            this.$refs['editAccountName'].$validator.errors.clear();
            const modalName = 'editAccountModal';

            this.editAccountName = account.name;
            this.editAccountService = account.serviceId;
            this.editAccountType = !account.type; // Important to turn around the boolean
            this.editAccountId = account.id;

            if (this.services === null) // Get the services and open the modal
                this.$http.get('v1.1/services/all').then(response => {
                    // Success callback
                    this.services = response.data.data.services;
                    this.createAccountService = this.services[0].id;

                    this.$refs[modalName].openModal();
                }, response => {
                    // Error callback
                    this.$parleyAdmin.queryErrors.addError('Something went wrong while retrieving the services list, please try again later.');
                });
            else // We already have services, so just open the modal
                this.$refs[modalName].openModal();
        },
        openDeleteModal: function() {
            this.$refs['deleteModal'].openModal();
        },
        closeModal: function(modalRef) {
            this.$refs[modalRef].closeModal();
        },
        createAccountValidation() {
            return this.$validator.validateAll().then((result) => {
                if (result)
                    this.createAccount();
            });
        },
        editAccountValidation() {
            return this.$validator.validateAll().then((result) => {
                if (result)
                    this.editAccount();
            });
        },
        createAccount: function() {
            const name = this.createAccountName;
            const serviceId = this.createAccountService;
            const type = this.createAccountType ? 0 : 1;

            this.$http.post('v1.1/accounts', {name: name, serviceId: serviceId, type: type}).then(response => {
                this.searchAccounts(true);
                this.closeModal('createAccountModal');
            }, response => {
                // Error callback
                this.$parleyAdmin.queryErrors.addError('Something went wrong while creating the account.');
            });
        },
        editAccount: function() {
            const name = this.editAccountName;
            const serviceId = this.editAccountService;
            const type = this.editAccountType ? 0 : 1;
            const id = this.editAccountId;

            this.$http.put('v1.1/accounts/' + id, {name: name, serviceId: serviceId, type: type}).then(response => {
                this.searchAccounts(true);
                this.closeModal('editAccountModal');
            }, response => {
                // Error callback
                this.$parleyAdmin.queryErrors.addError('Something went wrong while updating the account.');
            });
        },
        searchAccounts: debounce(function(firstTime = false) {
            // Clear accounts list
            this.accounts = [];

            this.$http.get('v1.1/accounts', {params: {searchTerm: this.searchTerm}}).then(async response => {
                const hasAccessToMultipleAccounts = response.data.data.accounts.length > 1;
                await this.$store.dispatch(this.$store.types.user.actions.hasAccessToMultipleAccounts, hasAccessToMultipleAccounts);

                if (firstTime === true && !hasAccessToMultipleAccounts)
                    this.logIntoAccount(response.data.data.accounts[0]);

                response.data.data.accounts.map(function(account) {
                    this.accounts.push(account);
                }.bind(this));
            }, response => {
                // Error callback
            }).bind(this);
        }, 500),
        logIntoAccount: async function(account) { // Logs the user into the account
            await this.$store.dispatch(this.$store.types.loggedinAccount.actions.set, account); // Save account info

            // Get rights for this user in the account
            this.$http.get('v1.1/rights').then(async response => {
                // Success callback
                await this.$store.dispatch(this.$store.types.user.actions.set, {rights: response.data.data.rights});
            }, response => {
                // Error callback
                this.$parleyAdmin.queryErrors.addError('Something went wrong while fetching the list of your permissions within this account. If you expirence any problems try to log out and back in.');
            });

            this.$router.push({name: 'home', params: {'identification': account.identification}}); // Go to home page
        },
        openEditModal: function(account) {
            this.openEditAccountModal(account);
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .row {
        width: 100%;
    }

    .header {
        padding: 1em;
        button {
            margin: 0 15px 0 15px;
        }
    }

    #account-list {
        //
    }

    .accounts-list {
        max-height: calc(100vh - 9em);
        overflow-y: auto;
        padding: 0 10px 0 10px;

        .not-found {
            width: 100%;
            height: 50vh;
            text-align: center;
            margin-top: 10em;

            .material-icons {
                color: $tertiary-color;
                font-size: 5em;
            }

            span {
                position: relative;
                top: -1.8em;
                user-select: none;
            }
        }
    }

    .accountListItem {
        border: 1px solid transparent;
        border-radius: 3px;
        background-color: white;
        width: 16em;
        height: 7em;
        margin: 6px;
        padding: 0;
        user-select: none;
        position: relative;

        section.clickable {
            width: 100%;
            height: 100%;
            padding: 5px;

            &:hover {
                background-color: lighten(#52D160,41%);
                border-color: lighten(#52D160,35%);
                cursor: default;
            }

            &:active {
                background-color: lighten(#52D160,38%);
                border-color: lighten(#52D160,30%);
                /*width: 256px;*/
                /*height: 96px;*/
                padding: 8px;
            }
        }

        i.material-icons.edit {
            margin: auto 0 0 auto;
            position: absolute;
            bottom: 0;
            right: 0;
            cursor: pointer;
            color: #c7c9d3;
        }

        h3 {
            font-size: 16px;
            color: #454d5a;
            font-weight: 400;
        }

        p {
            &.sub-text {
                color: #c7c9d3;
                font-size: 12px;
            }
        }


        .accountActions {
            i {
                padding: 20px 10px 20px 10px;
            }
        }

        .logIntoAccount {
            .accountIcon {
                width: 60px;
                height: 60px;
                padding: unset;
            }

            .accountInfo {
                padding-top: 10px;

                a {
                    color: #5378B7;
                    font-family: 'Montserrat', sans-serif;
                    font-weight: 400;
                    font-size: 14px;

                    &:hover {
                        opacity: 0.7;
                        text-decoration: none;
                    }
                }

                p:nth-of-type(1) {
                    font-weight: 400;
                    font-size: 14px;
                    padding-bottom: 5px;
                }

                p:nth-of-type(2) {
                    color: #A1A5B5;
                    font-size: 12px;
                }
            }
        }
    }

    #createAccountModal {
        .accountImgRow {
            padding-left: 0;

            .accountImg {
                $accountImgWidth: 125px;
                $accountImgHeight: 125px;
                background-color: #F2F5FA;
                height: $accountImgHeight;
                width: $accountImgWidth;
                border-radius: 4px;
                img {
                    height: $accountImgHeight;
                    width: $accountImgWidth;
                }
            }
        }

        .v-popover {
            cursor: pointer;
            height: 1em;
            margin-right: 2em;
        }
    }

    .search-bar {
        .search-bar-right {
            position: relative;

            .custom-input.search-account {
                width: 161px;
                background: #FFFFFF;
                border: 1px solid #E8EBF0;
                outline: none;
                font-size: 12px;
                font-weight: 400;
                border-radius: 100px;
                padding: 0 25px 0 0;
                margin: 2px 0 0 0;
                overflow: hidden;

                & ::v-deep .input {
                    background: #FFFFFF !important;
                    border: none;
                }
            }
            input[type=submit] {
                // background: url(../images/ic_search.png) no-repeat;
                background: url(../assets/images/ic_search.png) no-repeat;
                border: none;
                outline: none;
                cursor: pointer;
                width: 21px;
                height: 20px;
                position: absolute;
                right: 10px;
                top: 5px;
            }
        }
    }

    #context-menu {
        li {
            cursor: pointer;
            padding: .25em 2em;
            font-size: .8em;
        }
        li:hover {
            background-color: $primary-color;
        }
    }

    // Old stuff o hope
    .addCircle {
        width: 42px;
        height: 42px;
        border-radius: 21px;
    }

    .active {
        display: block;
    }

    .avatar ul {
        li:first-child {
            img {
                width: 25px;
                height: 25px;
            }
        }
    }
</style>
